(function() {
  'use strict';

  // Safety net: Globo's reveal animation can get stuck, leaving cards invisible.
  // After 8s, cancel stuck animations and force cards visible.
  (function globoSafetyNet() {
    var TIMEOUT = 8000;
    setTimeout(function() {
      document.querySelectorAll('.spf-product-card').forEach(function(card) {
        card.getAnimations().forEach(function(anim) { anim.cancel(); });
        card.style.visibility = 'visible';
        card.style.opacity = '1';
      });
      // Also handle stuck loading class
      document.documentElement.classList.remove('spf-filter-loading');
    }, TIMEOUT);
  })();

  // Fix Globo dropdown styling — CSS !important can't override Globo's late-injected styles
  (function fixGloboDropdowns() {
    var observer = new MutationObserver(function() {
      document.querySelectorAll('.globo-dropdown-custom__options').forEach(function(dd) {
        if (dd.dataset.styled) return;
        dd.style.setProperty('background-color', '#00111F', 'important');
        dd.style.setProperty('border', '1px solid rgba(255,255,255,0.1)', 'important');
        dd.querySelectorAll('span, a, li, div').forEach(function(el) {
          el.style.setProperty('color', '#FAFAFA', 'important');
        });
        dd.dataset.styled = 'true';
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();

  // Enrich Globo Smart Filter product cards with description, type tag, and color swatches.
  // Globo replaces the theme's native product grid, so we inject these via JS.

  var MAX_SWATCHES = 5;
  var COLOR_NAMES = ['color', 'colour', 'colore', 'farbe'];

  function stripHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function truncateWords(text, max) {
    var words = text.trim().split(/\s+/);
    if (words.length <= max) return text.trim();
    return words.slice(0, max).join(' ') + '...';
  }

  // --- Swatch helpers ---

  function findColorOption(product) {
    for (var i = 0; i < product.options.length; i++) {
      if (COLOR_NAMES.indexOf(product.options[i].name.toLowerCase()) !== -1) {
        return { name: product.options[i].name, position: i + 1 };
      }
    }
    return null;
  }

  function buildSwatches(product, productUrl) {
    var colorOpt = findColorOption(product);
    if (!colorOpt) return null;

    // Build image lookup from product.images (variants only have image_id, not featured_image)
    var imageMap = {};
    for (var k = 0; k < product.images.length; k++) {
      imageMap[product.images[k].id] = product.images[k].src;
    }

    var seen = {};
    var swatchData = [];
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var colorValue = v['option' + colorOpt.position];
      if (!colorValue || seen[colorValue]) continue;
      var imgSrc = v.image_id ? imageMap[v.image_id] : null;
      if (!imgSrc) continue;
      seen[colorValue] = true;
      swatchData.push({
        id: v.id,
        color: colorValue,
        imageSrc: imgSrc,
        productUrl: productUrl
      });
    }

    if (swatchData.length < 2) return null;

    var container = document.createElement('div');
    container.className = 'dc-swatches';

    var limit = Math.min(swatchData.length, MAX_SWATCHES);
    for (var j = 0; j < limit; j++) {
      var s = swatchData[j];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dc-swatch' + (j === 0 ? ' dc-swatch--selected' : '');
      btn.dataset.variantId = s.id;
      btn.dataset.imageSrc = s.imageSrc;
      btn.setAttribute('aria-label', s.color);
      btn.title = s.color;

      var img = document.createElement('img');
      img.src = s.imageSrc.replace(/\.([a-z]+)\?/, '_100x100_crop_center.$1?');
      img.alt = s.color;
      img.width = 36;
      img.height = 36;
      img.loading = 'lazy';
      btn.appendChild(img);
      container.appendChild(btn);
    }

    if (swatchData.length > MAX_SWATCHES) {
      var overflow = document.createElement('a');
      overflow.className = 'dc-swatch__overflow';
      overflow.href = productUrl;
      overflow.textContent = '+' + (swatchData.length - MAX_SWATCHES);
      container.appendChild(overflow);
    }

    return container;
  }

  // --- Card enrichment ---

  function enrichCard(card, product) {
    var info = card.querySelector('.spf-product__info');
    if (!info || card.dataset.enriched) return;
    card.dataset.enriched = 'true';

    if (product.body_html) {
      var desc = document.createElement('p');
      desc.className = 'product-card__description';
      desc.textContent = truncateWords(stripHtml(product.body_html), 15);
      info.appendChild(desc);
    }

    if (product.product_type) {
      var tag = document.createElement('span');
      tag.className = 'product-card__type-tag';
      tag.textContent = product.product_type;
      info.appendChild(tag);
    }

    var productLink = card.querySelector('a[href*="/products/"]');
    var productUrl = productLink ? productLink.href.split('?')[0] : '';
    var swatchContainer = buildSwatches(product, productUrl);
    if (swatchContainer) {
      info.appendChild(swatchContainer);
    }
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.href.match(/\/products\/([^?#/]+)/);
    return match ? match[1] : null;
  }

  var cache = {};

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.json')
      .then(function(r) { return r.json(); })
      .then(function(data) { return data.product; })
      .catch(function() { return null; });
    return cache[handle];
  }

  // Replace the vendor <a> (links to /collections/vendors?q=...) with a plain
  // <span> so users misclicking near the card no longer get sent to the vendor
  // collection. Vendor name stays; the wrapper's CSS still styles the span.
  // Idempotent: once it's a span there's no anchor left to replace.
  function neutralizeVendorLink(card) {
    var link = card.querySelector('.spf-product-card__vendor a');
    if (!link) return;
    var span = document.createElement('span');
    span.className = link.className;
    span.textContent = link.textContent;
    link.parentNode.replaceChild(span, link);
  }

  function enrichAllCards() {
    var cards = document.querySelectorAll('.spf-product-card:not([data-enriched])');
    cards.forEach(function(card) {
      neutralizeVendorLink(card);
      var handle = getHandleFromCard(card);
      if (!handle) return;
      fetchProduct(handle).then(function(product) {
        if (product) enrichCard(card, product);
      });
    });
  }

  // --- Swatch click handler (event delegation) ---

  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.dc-swatch');
    if (!swatch) return;

    var card = swatch.closest('.spf-product-card');
    if (!card) return;

    // Update selected state
    card.querySelectorAll('.dc-swatch').forEach(function(s) {
      s.classList.remove('dc-swatch--selected');
    });
    swatch.classList.add('dc-swatch--selected');

    // Swap card image — use the full CDN src, strip any existing size suffix
    var newSrc = swatch.dataset.imageSrc;
    var mainImg = card.querySelector('.spf-product-card__image-main');
    if (!mainImg) mainImg = card.querySelector('.spf-product-card__image:not(.spf-product-card__image-hidden)');
    if (mainImg && newSrc) {
      // Remove existing size suffix (e.g., _360x360) and add our own
      var sized = newSrc.replace(/_\d+x\d+[^.]*/, '_600x');
      mainImg.src = sized;
      if (mainImg.srcset) mainImg.removeAttribute('srcset');
    }

    // Update product links with variant ID
    var variantId = swatch.dataset.variantId;
    if (variantId) {
      card.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
        var base = link.href.split('?')[0];
        link.href = base + '?variant=' + variantId;
      });
    }
  });

  // --- Init ---

  function init() {
    enrichAllCards();

    var container = document.querySelector('.spf-product-list, [class*="spf-product"]');
    if (container && 'MutationObserver' in window) {
      var mo = new MutationObserver(function() {
        enrichAllCards();
      });
      mo.observe(container.parentElement || document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 1000);
    });
  } else {
    setTimeout(init, 1000);
  }
})();
